import { encryptor, getSymmetricKey } from '../Services/Crypto/Crypto';
import { validarRespuesta } from '../Services/crypto';


export const PrivateInterceptor = async(URL, method, body = undefined) => {

    // const key = await getSymmetricKey();
    // // console.log({key});
    // const encrypted = await encryptor(JSON.stringify({body, key}));

    let respuesta = null;
    const promesa = await fetch(`${process.env.REACT_APP_API_URL}/${URL}?${Date.now()}`, { 
        method: method,
        headers: {
            "Content-Type": "application/json",
            'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken)
        },
        body: JSON.stringify(body)
    })

    await promesa.json()
        .then(function (res) {
            // alert('stop')
            if(!res?.data?.valid){
                validarRespuesta(res);
            }
            respuesta =  res.data;
        })
        .catch((error) => {
            respuesta =  {error: error};
            console.error(respuesta);
        })
        return respuesta;
}


export const PrivateInterceptor2 = async (URL, method, body = undefined) => {
    let res = null;

    const promesa = await fetch(`${process.env.REACT_APP_API_URL}/${URL}?${Date.now()}`, { 
        method: method,
        headers: {
            "Content-Type": "application/json",
            'clave': '610a7bca571243b3a172dd97db1b2900'
        },
        body: body ? JSON.stringify(body) : undefined
    });

    if (!promesa.ok) {
        throw new Error(`HTTP error! status: ${promesa.status}`);
    }

    const resText = await promesa.text();
    res = JSON.parse(resText);

    if (!res?.data?.valid) {
        validarRespuesta(res);
    }
    // console.log(res)
    return res;
}
